module.exports = __webpack_public_path__ + "static/media/csrd_report_img3.03842711.svg";